module.exports = __webpack_public_path__ + "img/tp-trucks.860dc784.jpg";